/**
 * App state storage
 */

import Vue from 'vue'
import Vuex from 'vuex'
import * as getters from './getters'
import * as actions from './actions'
import * as mutations from './mutations'

Vue.use(Vuex)
const state = {
  auth: {
    isLoggedIn: !!localStorage.getItem('token'),
    accessToken: localStorage.getItem('token'),
    userData: JSON.parse(localStorage.getItem('userData')),
    userRole: null,
    company: null,
    pending: null,
    companyName: localStorage.getItem('userCompanyName') || null
  },
  content: [],
  companies: [],
  industries: [],
  defaultRegistrationRoles: [],
  sponsors: [],
  types: [],
  chapters: [],
  taskChapters: [],
  taskStatuses: [],
  taskAssignee: [],
  adminUsers: [],
  tags: [],
  actions: [],
  roles: [],
  categories: [],
  languages: [],
  confData: {
    id: null,
    actionId: null,
    actionName: null,
    showPopup: false,
    userStatus: null,
    actionConfirmed: false,
    customCancelButtonText: null,
    customConfirmButtonText: null,
    includeForm: false,
    feedbackText: null
  },
  informationMsg: {
    isShown: false,
    title: null,
    text: null,
    className: {'success': false, 'error': false, 'warning': false},
    style: {
    }
  },
  search: {
    searchString: null,
    contentTypes: [],
    topics: []
  },
  specialOps: {
    selectedFont: localStorage.getItem('selectedFont') ? +localStorage.getItem('selectedFont') : 0,
    fontOpt: {
      0: '16px',
      1: '19.2px',
      2: '22.4px'
    },
    selectedHightCont: localStorage.getItem('selectedHightCont') ? +localStorage.getItem('selectedHightCont') : 0,
    backgroundColor: {
      0: '#fff',
      1: '#000',
      2: '#fafac8'
    },
    color: {
      0: '#000',
      1: '#FFFA1A',
      2: '#000'
    }
  },
  consentRequired: localStorage.getItem('consentHead') ? localStorage.getItem('consentHead') : false,
  impersonatingUser: localStorage.getItem('impersonated') ? localStorage.getItem('impersonated') : false,
  tasks: {
    priorities: [
      {
        label: 'Low',
        value: 0
      },
      {
        label: 'Medium',
        value: 1
      },
      {
        label: 'High',
        value: 2
      }
    ],
    message: {
      allowedFileFormats: [
        'doc',
        'docx',
        'xls',
        'xlsx',
        'ppt',
        'pptx',
        'csv',
        'pdf',
        'txt',
        'zip',
        'odt',
        'ods',
        'odg',
        'odp',
        'gif',
        'jpg',
        'jpeg',
        'png'
      ]
    },
    backlogTasks: [],
    focusTasks: []
  },
  companySizes: [],
  companyLocations: []
}

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations
})



// WEBPACK FOOTER //
// ./src/store/index.js